<template>
  <div>
    <!-- Slider main container -->
    <div class="swiper-container w-screen" :style="containerHeight">
      <!-- Additional required wrapper -->
      <div class="swiper-wrapper">
        <!-- Slides -->
        <div v-for="({ fields }, i) in content" :key="i" class="swiper-slide">
          <div
            class="w-full h-full flex"
            :class="[
              fields.backgroundColor ? 'bg-black' : 'bg-white',
              { 'flex-row-reverse': fields.alignment }
            ]"
          >
            <ProjectsAsset
              :class="[
                assetHalfWidth(fields) && fields.asset.length === 1
                  ? 'half-width'
                  : 'w-full'
              ]"
              v-bind="fields"
              :asset="fields.asset[0]"
              :assetClass="
                `${backdrop ? '' : 'filter'} ${
                  fields.alignment ? 'ml-auto' : ''
                } w-full`
              "
            />
            <ProjectsAsset
              v-if="fields.asset.length > 1 && fields.halfWidth"
              class="w-full hidden lg:block"
              v-bind="fields"
              :asset="fields.asset[1]"
              :assetClass="`${backdrop ? '' : 'filter'} w-full`"
            />
            <!-- <div
              v-if="backdrop"
              class="backdrop fixed left-0 top-0 w-screen h-screen"
            ></div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from "lodash.debounce";
import { bind, unbind } from "@/utils/eventListner";
import { Swiper, EffectFade, Autoplay } from "swiper";
import { mapState } from "vuex";
import store from "@/store";
import ProjectsAsset from "./ProjectsAsset";

export default {
  name: "ProjectsSwiper",

  components: {
    ProjectsAsset
  },

  props: {
    content: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    w: 0,
    h: 0,
    backdrop: true
  }),

  computed: {
    ...mapState(["infoOpen"]),
    containerHeight() {
      return {
        height: `${this.h}px`
      };
    }
  },

  watch: {
    infoOpen(val) {
      // Disable/enable interaction
      this.swiper.allowTouchMove = !val;

      // Disable/enable autoplay
      this.swiper.autoplay[val ? "stop" : "start"]();

      // Set the progress circle
      this.$emit("handleTransition", val);
    }
  },

  async mounted() {
    // Select what css property to use
    this.backdrop = CSS.supports("backdrop-filter: blur(5px)");

    // Do this first to set slides correctly
    // this.handleResize();
    this.handleResize();
    this.debouncedResize = debounce(this.handleResize, 100);
    bind(window, "resize", this.debouncedResize);

    // Allow dom to update before initiating swiper
    await this.$nextTick();

    Swiper.use([EffectFade, Autoplay]);

    this.swiper = new Swiper(".swiper-container", {
      loop: true,
      virtual: true,
      speed: 800,
      effect: "fade",
      followFinger: false,
      allowTouchMove: false,
      fadeEffect: {
        crossFade: true
      },
      autoplay: {
        // Update the progress circle if you update this
        delay: 8000,
        disableOnInteraction: false
      }
    });

    // this.swiper.on("click", e => this.handleClick(e));

    this.swiper.on("slideChange", () =>
      this.$emit("handleSlideChange", this.swiper.realIndex)
    );
    // Triger events on instanciation
    this.$emit("handleSlideChange", this.swiper.realIndex);

    // Emit events for progress circle and handle click
    this.swiper.on("touchStart", (_, e) => this.handleTouchStart(e));
    this.swiper.on("touchEnd", (_, e) => this.handleTouchEnd(e));
    this.swiper.on("transitionStart", () =>
      this.$emit("handleTransition", true)
    );
    this.swiper.on("transitionEnd", () =>
      this.$emit("handleTransition", false)
    );
  },

  beforeDestroy() {
    unbind(window, "resize", this.debouncedResize);
  },

  methods: {
    handleTouchStart() {
      this.$emit("handleTransition", true);
      this.swiper.autoplay.stop();
    },
    handleTouchEnd(e) {
      this.$emit("handleTransition", false);
      this.handleClick(e);
      this.swiper.autoplay.start();
    },
    handleClick(e) {
      if (!this.infoOpen) {
        // Default to only forwards swipe (including Touch events)
        this.swiper[e.clientX < this.w / 2 ? "slidePrev" : "slideNext"]();
      } else {
        store.commit("setInfoOpen", false);
      }
    },
    handleResize() {
      this.w = window.innerWidth;
      this.h = window.innerHeight;
    },
    assetHalfWidth(fields) {
      return (
        (fields.asset.length === 1 ||
          fields.asset[0].fields.file.contentType === "video/mp4") &&
        fields.halfWidth
      );
    }
  }
};
</script>

<style>
/* purgecss start ignore */
/* @import "swiper/css/swiper.css"; */
@import "swiper/swiper-bundle.css";

.half-width {
  width: 100%;
}
@media (min-width: 800px) {
  .half-width {
    width: 50%;
  }
}
/* purgecss end ignore */
</style>
